// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__22JA1","requiredAsterisk":"Info_requiredAsterisk__1zlSW"};